import React from 'react'

import { Formik } from 'formik'

import { Form, Modal, Button } from '_zari/core'

import * as FormGroups from './formGroups'
import * as Sections from '../_shared/sections'

const CajaBancoModal = ({ show, handleClose, modalData, submitFunction, esAvanzado }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      ...modalData,
      flujoEfectivo: modalData.flujoEfectivo || '',
      medioDePago: modalData.medioDePago || '',
      numeroDocumentoPago: modalData.numeroDocumentoPago || ''
    }
  }, [modalData])

  const onSubmit = React.useCallback(
    data => {
      submitFunction({
        ...data,
        modalValido: true
      })
    },
    [submitFunction]
  )

  return (
    <Modal show={show} centered>
      <Modal.Header>
        <Modal.Title>{esAvanzado ? 'EDICION AVANZADA' : 'CAJA/BANCOS'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, handleSubmit, handleChange, setFieldValue, setValues }) => (
          <>
            <Modal.Body>
              <Form>
                {esAvanzado && (
                  <Sections.ComunSection
                    errors={errors}
                    touched={touched}
                    isSubmitting={isSubmitting}
                    handleChange={handleChange}
                    values={values}
                    setFieldValue={setFieldValue}
                    setValues={setValues}
                    nextNodeId='select-medioDePago'
                  />
                )}
                <FormGroups.MedioPagoFormGroup
                  iValue={values.medioDePago}
                  iError={errors.medioDePago}
                  iTouched={touched.medioDePago}
                  fIsSubmitting={isSubmitting}
                />
                <FormGroups.NumeroDocumentoPagoFormGroup
                  iError={errors.numeroDocumentoPago}
                  iTouched={touched.numeroDocumentoPago}
                  fIsSubmitting={isSubmitting}
                />
                <FormGroups.FlujoEfectivoFormGroup iError={errors.flujoEfectivo} iTouched={touched.flujoEfectivo} fIsSubmitting={isSubmitting} />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose} disabled={isSubmitting}>
                Cancelar
              </Button>
              <Button id='button-cajabancomodal-procesar' onClick={handleSubmit} disabled={isSubmitting}>
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(CajaBancoModal)
